import { useContext, useEffect, useRef, useState } from "react"
import { useMemo } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { useCommon } from "../../Common/useCommon";
import _ from "underscore";
import { callautopopulate } from '../../../services/callautopop.js';
import { calculateWordsFromString, convertToBase64, dateConvert } from "../../../utils/Helper.js"
import { DateTime } from "luxon";

export const useUserRegistration = ({ setAddUserPopup, getTeamOverViewList, userEditData, resetEditUserData, projectLead }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const { handleValidation } = useCommon();
    const tagRef = useRef(null);
    const fileRef = useRef(null);
    const [usersOptions, setUsersOptions] = useState([]);
    const [unitOptions, setUnitOptions] = useState([]);
    const [userStatusOptions, setUserStatusOptions] = useState([]);
    const [uploadImage, setUploadImage] = useState(null);
    const [formValues, setFormValues] = useState({ user_Name: "", user_login_name: "", user_category_id: 0, employee_id: "", reporting_employee_id: "", email_id: "", is_active: false, gender: "", is_client: false, requested_user_code: 0, is_block: false, user_status_id: 0, original_joining_date: null, is_billable: false, primary_project_id: 0 });
    const [groupFilters, setGroupFilters] = useState({ lead: null, users: [], unit: {}, date: new Date() });
    const [filteredUserOptions, setFilteredUserOptions] = useState([]);
    const [loader, setLoader] = useState({ loaderGrid: false, loaderBtn: false, uploadLoader: false, saveLoader: false });
    const [imageProp, setImageProp] = useState(userEditData?.image_url);
    const [showRemarkPopup, setShowRemarkPopup] = useState(false);
    const [userStatus, setUserStatus] = useState({ prev: "", curr: "" });
    const [updateStatus, setUpdateStatus] = useState({ remark: "", projects: null })
    const [statusRowData, setStatusRowData] = useState([]);
    const [statusLoader, setStatusLoader] = useState({ grid: false, btn: false });
    const [statusUpdateFlag, setStatusUpdateFlag] = useState(false);
    const [profileError, setProfileError] = useState("");
    const [projectOpts, setProjectOpts] = useState([]);
    const [statusColdef] = useState([
        {
            field: "user_status_name",
            headerName: "Status",
            flex: 1,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "from_datetime",
            headerName: "From Date",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, "date-time-months")}</div>
                )
            }
        },
        {
            field: "to_datetime",
            headerName: "To Date",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, "date-time-months")}</div>
                )
            }
        },
        {
            field: "created_by_name",
            headerName: "Updated By",
            flex: 1,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "remarks",
            headerName: "Remarks",
            flex: 4
        },

    ])
    const [rowData, setRowData] = useState([]);
    const [columnDef] = useState([
        {
            field: "start_date",
            headerName: "Start Date",
            flex: 0.5,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "end_date",
            headerName: "End Date",
            flex: 0.5,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "unit",
            headerName: "Unit",
            flex: 1
        },
    ]);

    useEffect(() => {
        sessionStorage.removeItem("users");
        callautopopulate("day_calendar_groups", "users", "user_status", "projects")?.then((res) => {
            setUnitOptions(_.sortBy(res?.day_calendar_groups, (item) => item?.group_name?.toLowerCase()));
            setUsersOptions(_.sortBy(res?.users, "user_display_name"));
            setUserStatusOptions(_.sortBy(res?.user_status))
            setProjectOpts(_.sortBy(res?.projects, "project_name"));
        })

        if (!_.isEmpty(userEditData)) {

            getUserStatusRemark();
            handleEdit();
        }
    }, [userEditData])

    useEffect(() => {
        if (groupFilters?.lead) {
            const users = _.filter(usersOptions, { reporting_employee_id: groupFilters?.lead?.employee_id });
            setFilteredUserOptions(users);
        } else {
            setFilteredUserOptions(usersOptions)
        }

        // set default selection for unit section
        if (!_.isEmpty(userEditData)) {
            const lead = _.findWhere(projectLead, { employee_id: userEditData?.reporting_employee_id });
            const user = _.findWhere(usersOptions, { user_code: userEditData?.user_code }) || {};
            setGroupFilters((prev) => ({ ...prev, users: [user], lead: lead }))
        }
    }, [usersOptions, groupFilters?.lead])

    const handleEdit = () => {
        const obj = {
            user_Name: userEditData?.user_display_name,
            user_login_name: userEditData?.user_loginname !== null ? userEditData?.user_loginname : "",
            user_category_id: userEditData?.user_category_id !== null ? userEditData?.user_category_id : 0,
            employee_id: userEditData?.employee_id !== null ? userEditData?.employee_id : "",
            reporting_employee_id: userEditData?.reporting_employee_id !== null ? userEditData?.reporting_employee_id : "",
            email_id: userEditData?.email_id !== null ? userEditData?.email_id : "",
            is_active: userEditData?.employee_status !== null ? userEditData?.employee_status : false,
            gender: userEditData?.gender?.trim(),
            is_client: userEditData?.is_client !== null ? userEditData?.is_client : false,
            requested_user_code: userEditData?.user_code !== null ? userEditData?.user_code : 0,
            is_block: userEditData?.is_blocked !== null ? userEditData?.is_blocked : false,
            user_status_id: userEditData?.user_status_id !== null ? userEditData?.user_status_id : 0,
            original_joining_date: userEditData?.joining_date || null,
            is_billable: userEditData?.is_billable || false,
            primary_project_id: userEditData?.primary_project_id !== null ? userEditData?.primary_project_id : 0,


        }
        setFormValues(obj)
        if (userEditData?.unit_data) {
            let arr = [];
            _.sortBy(userEditData?.unit_data, "effective_start_date")?.forEach((item) => {
                const obj = {
                    start_date: item?.effective_start_date ? DateTime.fromISO(item?.effective_start_date).toFormat('dd MMM yyyy') : "",
                    end_date: item?.effective_end_date ? DateTime.fromISO(item?.effective_end_date).toFormat('dd MMM yyyy') : "",
                    unit: item?.group_name
                }
                arr.push(obj);
            })
            setRowData(arr);
            setLoader((prev) => ({ ...prev, loaderGrid: false }));
        }
        setImageProp(userEditData?.image_url);
    }

    const handleSubmit = async () => {
        try {
            const validateEmail = await handleValidation("", formValues?.email_id);
            if (!formValues?.user_Name) {
                showInfo("info", "Please enter the user name");
                return;
            } else if (formValues?.user_category_id === 0) {
                showInfo("info", "Please select the user category");
                return;
            } else if (!formValues?.email_id) {
                showInfo("info", "Please enter the email-id");
                return;
            } else if (!validateEmail) {
                showInfo("info", "Please enter valid email");
                return;
            } else if (!formValues?.gender) {
                showInfo("info", "Please select the gender");
                return;
            }
            const payload = formValues;
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERDETAILS"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                getTeamOverViewList();
                if (_.isEmpty(userEditData)) {
                    setFormValues({ user_Name: "", user_login_name: "", user_category_id: 0, employee_id: "", reporting_employee_id: "", email_id: "", is_active: false, gender: "", is_client: false, requested_user_code: 0, is_block: false, original_joining_date: null, is_billable: false, primary_project_id: 0 });
                    setAddUserPopup(false);
                    resetEditUserData({});
                }
            }
        } catch (error) {
            console.error("error: ", error);
        }
    }

    const handleUploadClicked = () => {
        setLoader((prev) => ({ ...prev, uploadLoader: true }));
        fileRef.current.click();
        setTimeout(() => {
            setLoader((prev) => ({ ...prev, uploadLoader: false }));
        }, 3000);
    }

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        const maxSizeInBytes = 20 * 1024 * 1024;
        if (file?.size >= maxSizeInBytes) {
            setProfileError("File size should not exceed 20MB");
            setLoader((prev) => ({ ...prev, uploadLoader: false }));
            return;
        } else {
            setProfileError("");
        }
        if (file && file.type.startsWith('image/')) {
            try {
                const base64 = await convertToBase64(file);
                setUploadImage(base64);
                setLoader((prev) => ({ ...prev, uploadLoader: false }));
            } catch (error) {
                console.error("Error converting file to base64:", error);
                setLoader((prev) => ({ ...prev, uploadLoader: false }));
            }
        }
    };

    const handleUpsertGroup = async () => {
        try {
            setLoader({ loaderGrid: true, loaderBtn: true, uploadLoader: false });
            if (_.isEmpty(groupFilters?.users)) {
                showInfo("Info", "Please select users");
                setLoader({ loaderGrid: false, loaderBtn: false, uploadLoader: false });
                return;
            } else if (_.isEmpty(groupFilters?.unit)) {
                showInfo("Info", "Please select a unit to assign");
                setLoader({ loaderGrid: false, loaderBtn: false, uploadLoader: false });
                return;
            } else if (!groupFilters?.date) {
                showInfo("Info", "Please select date");
                setLoader({ loaderGrid: false, loaderBtn: false, uploadLoader: false });
                return;
            }
            const payload = {
                user_ids: _.pluck(groupFilters?.users, "user_code")?.toString(),
                group_id: groupFilters?.unit?.group_id,
                from_date: dateConvert(groupFilters?.date, "iso-string")
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTASSIGNGROUPTOMULTIUSERS"), payload);
            if (!res?.body?.error_status) {
                if (res?.body?.StatusCode === 202) {
                    showError("Error", res?.body?.errorMessage);
                    setLoader({ loaderGrid: false, loaderBtn: false, uploadLoader: false });
                    return;
                }
                showSuccess("Success", res?.body?.message);
                setGroupFilters({ lead: null, users: [], unit: {}, date: new Date() });
                getTeamOverViewList();
                setLoader((prev) => ({ ...prev, loaderBtn: false }));
            } else {
                showError("Error", res?.body?.message);
                setLoader({ loaderGrid: false, loaderBtn: false, uploadLoader: false });
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader({ loaderGrid: false, loaderBtn: false, uploadLoader: false });
        }
    }

    const handleSaveImage = async () => {
        try {
            setLoader((prev) => ({ ...prev, saveLoader: true }));
            if (profileError) {
                showInfo("Info", profileError);
                setLoader((prev) => ({ ...prev, saveLoader: false }));
                return;
            } else if (!uploadImage) {
                showInfo("info", "No new image selected");
                setLoader((prev) => ({ ...prev, saveLoader: false }));
                return;
            }
            const payload = {
                requested_user_code: userEditData?.user_code,
                base64_image_string: uploadImage?.split(",")?.[1]
            }
            const res = await services.getInvokeRemote("POST", Urls("PROFILEIMAGESAVE"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setImageProp(null);
                getTeamOverViewList();
                setLoader((prev) => ({ ...prev, saveLoader: false }));
            } else {
                showError("error", res?.body?.message);
                setLoader((prev) => ({ ...prev, saveLoader: false }));
            }
        } catch (error) {
            console.error("Error uploading image: ", error);
            setLoader((prev) => ({ ...prev, saveLoader: false }));
        }
    }

    const handleUserStatusChange = (e) => {
        if (e.target.value?.user_status_id === formValues?.user_status_id) {
            return;
        } else {
            const prev = _.findWhere(userStatusOptions, { user_status_id: formValues?.user_status_id });
            const curr = e.target.value;
            setUserStatus({ prev: _.isEmpty(prev) ? "none" : prev, curr: curr });
            setUpdateStatus({ remark: "", projects: null })
            setShowRemarkPopup(true);
        }
    }

    const getUserStatusRemark = async () => {
        try {
            setStatusLoader((prev) => ({ ...prev, grid: true }));
            const payload = {
                requested_user_code: userEditData?.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUSERSTATUSREMARK"), payload);
            if (res) {
                let data = res?.body?.data?.user_status_remarks_list;
                data = data.sort((a, b) => { return new Date(b?.from_datetime) - new Date(a?.from_datetime) });
                setStatusRowData(data);
                setStatusLoader((prev) => ({ ...prev, grid: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setStatusLoader((prev) => ({ ...prev, grid: false }));
        }
    }

    const saveUserStatusRemark = async () => {
        try {
            if (userStatus?.curr?.user_status_key === "in_project" && !updateStatus?.projects) {
                showInfo("Info", "Please select a project");
                return;
            }
            if (!updateStatus?.remark || calculateWordsFromString(updateStatus?.remark) < 10) {
                showInfo("Info", "Please enter remark of atleast 10 words");
                return;
            }
            setStatusLoader((prev) => ({ ...prev, btn: true }));
            const payload = {
                requested_user_code: userEditData?.user_code,
                user_status_id: userStatus?.curr?.user_status_id,
                remarks: updateStatus?.remark,
                project_id: updateStatus?.projects?.project_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEUSERSTATUSREMARK"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                setShowRemarkPopup(false);
                setFormValues((prev) => ({ ...prev, user_status_id: userStatus?.curr?.user_status_id, primary_project_id: userStatus?.curr?.user_status_key === "in_project" ? updateStatus?.projects?.project_id : prev?.primary_project_id }));
                getUserStatusRemark();
                setStatusLoader((prev) => ({ ...prev, btn: false }));
                setStatusUpdateFlag(true);
            }
        } catch (error) {
            console.error("Error: ", error);
            setStatusLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    return useMemo(() => ({
        projectOpts, setProjectOpts,
        tagRef, formValues, setFormValues, handleSubmit, fileRef, handleFileChange, uploadImage, unitOptions, groupFilters, setGroupFilters, filteredUserOptions, rowData, columnDef, handleUpsertGroup, loader, setLoader, handleSaveImage, imageProp, handleUploadClicked, userStatusOptions, handleUserStatusChange, showRemarkPopup, setShowRemarkPopup, userStatus, saveUserStatusRemark, updateStatus, setUpdateStatus, statusColdef, statusRowData, statusLoader, statusUpdateFlag, setStatusUpdateFlag, profileError
    }), [projectOpts, setProjectOpts, tagRef, formValues, setFormValues, handleSubmit, fileRef, handleFileChange, uploadImage, unitOptions, groupFilters, setGroupFilters, filteredUserOptions, rowData, columnDef, handleUpsertGroup, loader, setLoader, handleSaveImage, imageProp, handleUploadClicked, userStatusOptions, handleUserStatusChange, showRemarkPopup, setShowRemarkPopup, userStatus, saveUserStatusRemark, updateStatus, setUpdateStatus, statusColdef, statusRowData, statusLoader, statusUpdateFlag, setStatusUpdateFlag, profileError])
}